import { API_VERSIONS, asinzenAdminApi } from "client/api";

export const getListKeepaKeys = () =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/keepa-keys/list`);

export const checkKeepaKey = (params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/keepa-keys/check`, params)